import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';

interface ISetTeamTemplateResponse {
    message: string,
}

export default function useSetTeamTemplates() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      // eslint-disable-next-line camelcase
      template_ids,
    }: { teamId: string; template_ids: string[]; }) => apiFetch<ISetTeamTemplateResponse>({
      path: `team/${teamId}/templates`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: {
        // eslint-disable-next-line camelcase
        template_ids,
      },
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamCampaignTemplates', { teamId: variables.teamId }],
      });
    },
  });
}
